'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopDefault(ex) {
  return ex && typeof ex === 'object' && 'default' in ex ? ex['default'] : ex;
}

var _tslib = require('../_tslib-bcbe0269.js');

var core = require('@emotion/core');

var React = require('react');

var React__default = _interopDefault(React);

var IconRobot1 = React__default.forwardRef(function (_a, ref) {
  var _b = _a.weight,
      weight = _b === void 0 ? "normal" : _b,
      props = _tslib.__rest(_a, ["weight"]);

  return core.jsx("svg", _tslib.__assign({
    viewBox: "0 0 24 24",
    ref: ref,
    css: core.css(templateObject_1 || (templateObject_1 = _tslib.__makeTemplateObject(["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "], ["\n        * {\n          vector-effect: non-scaling-stroke;\n        }\n        overflow: visible;\n        height: 24px;\n      "])))
  }, props), core.jsx("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: weight === "normal" ? 1.5 : 1
  }, core.jsx("path", {
    d: "M.75 16.5a1.5 1.5 0 0 1 3 0M2.25 15V9.75a3 3 0 0 1 3-3h1.5M23.25 16.5a1.5 1.5 0 0 0-3 0"
  }), core.jsx("path", {
    d: "M21.75 15V9.75a3 3 0 0 0-3-3h-1.5M17.25 6.75a10.88 10.88 0 0 1 .75 4.5 14.047 14.047 0 0 1-.372 3.363 1.5 1.5 0 0 1-1.456 1.137H7.828a1.5 1.5 0 0 1-1.456-1.137A14.047 14.047 0 0 1 6 11.25a10.88 10.88 0 0 1 .75-4.5h10.5z"
  }), core.jsx("path", {
    d: "M10.5 15.75v6.75a.75.75 0 0 1-.75.75H7.5v-7.536M5.25 23.25H7.5M13.5 15.75v6.75c0 .414.336.75.75.75h2.25v-7.536M18.75 23.25H16.5M12 .75a3 3 0 0 0-3 3v3h6v-3a3 3 0 0 0-3-3zM14.625 9.75c.207 0 .375.168.375.375M14.25 10.125c0-.207.168-.375.375-.375M14.625 10.5a.375.375 0 0 1-.375-.375M15 10.125a.375.375 0 0 1-.375.375M9 10.5h2.25"
  })));
});
var templateObject_1;
exports.IconRobot1 = IconRobot1;